import { InjectionToken, Signal } from '@angular/core';

/**
 * Supplies live visibility state for navigation nodes. A node is shown by
 * default; a registered provider can HIDE it reactively (e.g. a tab whose
 * underlying data is not configured). Returns `false` to hide the node for
 * the given id, `true` (or no opinion) to leave it visible.
 *
 * Mirrors {@link NavBadgeProvider}: a multi-provided, keyed-`Signal` seam the
 * tab surface resolves consumer-side. The {@link NavRegistry} stays pure —
 * visibility is never baked into the descriptor tree.
 */
export interface NavVisibilityProvider {
  visibleFor(navId: string): Signal<boolean>;
}

/**
 * Multi-provider token for {@link NavVisibilityProvider} implementations.
 */
export const NAV_VISIBILITY_PROVIDER = new InjectionToken<NavVisibilityProvider>(
  'NAV_VISIBILITY_PROVIDER',
);
